import { c as _c } from "react/compiler-runtime";
import { useState, useCallback, useEffect } from 'react';
interface UseCarouselOptions {
  itemsPerView?: number;
  transitionDuration?: number;
}
interface UseCarouselReturn {
  isDesktop: boolean;
  currentSlide: number;
  isTransitioning: boolean;
  totalSlides: number;
  showArrows: boolean;
  goToSlide: (slideIndex: number) => void;
  nextSlide: () => void;
  prevSlide: () => void;
  getVisibleItems: <T>(items: T[]) => T[];
}
export const useCarousel = (itemCount, t0) => {
  const $ = _c(27);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const options = t1;
  const {
    itemsPerView: t2,
    transitionDuration: t3
  } = options;
  const itemsPerView = t2 === undefined ? 4 : t2;
  const transitionDuration = t3 === undefined ? 100 : t3;
  const [isDesktop, setIsDesktop] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  let t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      const checkScreenSize = () => {
        const isDesktopQuery = window.matchMedia("(min-width: 768px)");
        setIsDesktop(isDesktopQuery.matches);
      };
      checkScreenSize();
      window.addEventListener("resize", checkScreenSize);
      return () => window.removeEventListener("resize", checkScreenSize);
    };
    t5 = [];
    $[2] = t4;
    $[3] = t5;
  } else {
    t4 = $[2];
    t5 = $[3];
  }
  useEffect(t4, t5);
  const totalSlides = Math.ceil(itemCount / itemsPerView);
  const showArrows = isDesktop && itemCount > itemsPerView;
  let t6;
  if ($[4] !== isTransitioning || $[5] !== totalSlides || $[6] !== transitionDuration) {
    t6 = slideIndex => {
      if (slideIndex < 0 || slideIndex >= totalSlides || isTransitioning) {
        return;
      }
      setIsTransitioning(true);
      setCurrentSlide(slideIndex);
      setTimeout(() => setIsTransitioning(false), transitionDuration);
    };
    $[4] = isTransitioning;
    $[5] = totalSlides;
    $[6] = transitionDuration;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const goToSlide = t6;
  let t7;
  if ($[8] !== currentSlide || $[9] !== goToSlide) {
    t7 = () => goToSlide(currentSlide + 1);
    $[8] = currentSlide;
    $[9] = goToSlide;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const nextSlide = t7;
  let t8;
  if ($[11] !== currentSlide || $[12] !== goToSlide) {
    t8 = () => goToSlide(currentSlide - 1);
    $[11] = currentSlide;
    $[12] = goToSlide;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const prevSlide = t8;
  let t9;
  if ($[14] !== currentSlide || $[15] !== itemsPerView) {
    t9 = items => {
      const startIndex = currentSlide * itemsPerView;
      return items.slice(startIndex, startIndex + itemsPerView);
    };
    $[14] = currentSlide;
    $[15] = itemsPerView;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const getVisibleItems = t9;
  let t10;
  if ($[17] !== currentSlide || $[18] !== getVisibleItems || $[19] !== goToSlide || $[20] !== isDesktop || $[21] !== isTransitioning || $[22] !== nextSlide || $[23] !== prevSlide || $[24] !== showArrows || $[25] !== totalSlides) {
    t10 = {
      isDesktop,
      currentSlide,
      isTransitioning,
      totalSlides,
      showArrows,
      goToSlide,
      nextSlide,
      prevSlide,
      getVisibleItems
    };
    $[17] = currentSlide;
    $[18] = getVisibleItems;
    $[19] = goToSlide;
    $[20] = isDesktop;
    $[21] = isTransitioning;
    $[22] = nextSlide;
    $[23] = prevSlide;
    $[24] = showArrows;
    $[25] = totalSlides;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
};